/**
 * Created by wangxiaobo on 18/12/17.
 */
import personalRouter from '../common/personalRouter';

export default [
  {
    path: '/personal',
    name: 'personal',
    component: () => import('@/views/personal/index.vue'),
    redirect: '/personal/userManagement',
    children: [
      ...personalRouter,
      {
        path: 'faceAuth',
        name: 'personalFaceAuth',
        meta: { mustLogin: true, navName: 'userManagement' },
        component: () => import('@/views/personal/kycAuth.vue'),
      },
      {
        path: 'kycAuth',
        name: 'personalKycAuth',
        meta: { mustLogin: true, navName: 'userManagement' },
        component: () => import('@/views/personal/kycAuthselect.vue'),
      },
      {
        path: 'exccAuthForm',
        name: 'personalExccAuthForm',
        meta: { mustLogin: true, navName: 'userManagement' },
        component: () => import('@/views/personal/exccAuthForm.vue'),
      },
      {
        path: 'exccAuthorization',
        name: 'personalExccAuthorization',
        meta: { mustLogin: true, navName: 'userManagement' },
        component: () => import('@/views/personal/exccAuthorization.vue'),
      },
    ],
  },
];
